import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AppShell } from "@/components/layout/AppShell";
import { RouteGuard } from "@/components/layout/RouteGuard";
import UsageAndCostPage from "@/features/usage";

/**
 * Usage & Cost.
 *
 * An easy one: 19 files and ~4,000 lines, but zero react-router and zero MUI —
 * it was already built on shadcn and react-query. The only thing holding it in
 * the legacy tree was the DashboardLayout it rendered.
 *
 * No `allow`: the legacy route was <ProtectedRoute> alone, with no permission
 * wrapper. Authentication is the whole guard.
 *
 * The screen's heading is the top bar's, not the page's. The page used to render
 * its own <h1> with this same string, which printed it twice once the shell
 * supplied one — so the <h1> is gone and this is the only copy.
 */
const UsageRoute = () => {
  const { t } = useTranslation();
  return (
    <RouteGuard>
      <AppShell title={t("usageAndCost.title")}>
        <UsageAndCostPage />
      </AppShell>
    </RouteGuard>
  );
};

export const Route = createFileRoute("/usage")({
  component: UsageRoute,
});
